/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */


import {NgModule} from '@angular/core';
import {MdInput} from './input';
import {MdTextareaAutosize} from './autosize';
import {CommonModule} from '@angular/common';
import {PlatformModule} from '@angular/material/core';
import {MdFormFieldModule} from '@angular/material/form-field';
export class MdInputModule {static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  declarations: [
    MdInput,
    MdTextareaAutosize,
  ],
  imports: [
    CommonModule,
    MdFormFieldModule,
    PlatformModule,
  ],
  exports: [
    // We re-export the `MdFormFieldModule` since `MdInput` will almost always be used together with
    // `MdFormField`.
    MdFormFieldModule,
    MdInput,
    MdTextareaAutosize,
  ],
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function MdInputModule_tsickle_Closure_declarations() {
/** @type {?} */
MdInputModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
MdInputModule.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
